// React
import React from "react";
// Framework
import { usePortal, forwardType, External, Externals } from "@mefisto/web";
// Components
import AppIcon from "./images/app-icon.png";
import CaribenoIntroPoster from "./images/caribeno-intro-poster.png";
import CaribenoInterviewsPoster from "./images/caribeno-interviews-poster.png";
import OnboardingBackground from "./images/onboarding-background.png";
import OnboardingBackgroundLarge from "./images/onboarding-background-large.png";
import SplashScreen from "./images/splash-screen.png";
import LogoAnimationMov from "./videos/logo-animation.mov";
import LogoAnimationWebm from "./videos/logo-animation.webm";
import Introduction from "./videos/introduction.mp4";
import ShowcaseMov1x from "./videos/showcase.mov";
import ShowcaseWebm1x from "./videos/showcase.webm";
import ShowcasePoster from "./images/showcase-poster.png";
import SpinnerBeach from "./images/spinner-beach.json";
import Bonus1Mov1x from "./videos/bonus1.mov";
import Bonus1Webm1x from "./videos/bonus1.webm";
import Bonus1Poster from "./images/bonus1.png";
import Bonus2Mov1x from "./videos/bonus2.mov";
import Bonus2Webm1x from "./videos/bonus2.webm";
import Bonus2Poster from "./images/bonus2.png";
import Bonus3Mov1x from "./videos/bonus3.mov";
import Bonus3Webm1x from "./videos/bonus3.webm";
import Bonus3Poster from "./images/bonus3.png";
import Calendar from "./images/calendar.png";
import Step1Mov1x from "./videos/step1.mov";
import Step1Webm1x from "./videos/step1.webm";
import Step1Poster from "./images/step1.png";
import Step2Mov1x from "./videos/step2.mov";
import Step2Webm1x from "./videos/step2.webm";
import Step2Poster from "./images/step2.png";
import Step3Mov1x from "./videos/step3.mov";
import Step3Webm1x from "./videos/step3.webm";
import Step3Poster from "./images/step3.png";
import Testimonial1 from "./images/testimonial-1.jpeg";
import Testimonial2 from "./images/testimonial-2.jpeg";
import Testimonial3 from "./images/testimonial-3.jpeg";
import WorkoutBody from "./images/workout-body.png";
import UpperBody from "./images/upper-body.png";
import LowerBody from "./images/lower-body.png";
import LocationHome from "./images/location-home.png";
import LocationGym from "./images/location-gym.png";
import BodySectionAbdomen from "./images/body-section-abdomen.png";
import BodySectionAbductors from "./images/body-section-abductors.png";
import BodySectionAdductors from "./images/body-section-adductors.png";
import BodySectionBack from "./images/body-section-back.png";
import BodySectionBiceps from "./images/body-section-biceps.png";
import BodySectionCalves from "./images/body-section-calves.png";
import BodySectionChest from "./images/body-section-chest.png";
import BodySectionGlutes from "./images/body-section-glutes.png";
import BodySectionHamstrings from "./images/body-section-hamstrings.png";
import BodySectionQuadriceps from "./images/body-section-quadriceps.png";
import BodySectionShoulders from "./images/body-section-shoulders.png";
import BodySectionSpinals from "./images/body-section-spinals.png";
import BodySectionTriceps from "./images/body-section-triceps.png";
import ThreeDays from "./images/three-days.png";
import FourDays from "./images/four-days.png";
import Results from "./videos/results.mp4";
import ResultsPoster from "./images/results-poster.jpg";

export default forwardType(Externals, () => {
  // Framework
  const { config } = usePortal();
  // prettier-ignore
  return (
    <Externals>
      {/* Images */}
      <External name="APP_ICON" path={AppIcon} />
      <External name="CARIBENO_INTRO_POSTER" path={CaribenoIntroPoster} />
      <External name="CARIBENO_INTRO_VIDEO" path={config.get("appsPresentationAssetsIntroVideo")} />
      <External name="CARIBENO_INTERVIEWS_POSTER" path={CaribenoInterviewsPoster} />
      <External name="CARIBENO_INTERVIEWS_VIDEO" path={config.get("appsPresentationAssetsInterviewsVideo")} />
      <External name="ONBOARDING_BACKGROUND" path={OnboardingBackground} />
      <External name="ONBOARDING_BACKGROUND_LARGE" path={OnboardingBackgroundLarge} />
      <External name="SPINNER_BEACH" path={SpinnerBeach} />
      <External name="SPLASH_SCREEN" path={SplashScreen} />
      <External name="STEP1_POSTER" path={Step1Poster} />
      <External name="STEP2_POSTER" path={Step2Poster} />
      <External name="STEP3_POSTER" path={Step3Poster} />
      <External name="BONUS1_POSTER" path={Bonus1Poster} />
      <External name="BONUS2_POSTER" path={Bonus2Poster} />
      <External name="BONUS3_POSTER" path={Bonus3Poster} />
      <External name="CALENDAR" path={Calendar} />
      <External name="SHOWCASE_POSTER" path={ShowcasePoster} />
      <External name="WORKOUT_BODY" path={WorkoutBody} />
      <External name="UPPER_BODY" path={UpperBody} />
      <External name="LOWER_BODY" path={LowerBody} />
      <External name="LOCATION_HOME" path={LocationHome} />
      <External name="LOCATION_GYM" path={LocationGym} />
      <External name="BODY_SECTION_ABDOMEN" path={BodySectionAbdomen} />
      <External name="BODY_SECTION_ABDUCTORS" path={BodySectionAbductors} />
      <External name="BODY_SECTION_ADDUCTORS" path={BodySectionAdductors} />
      <External name="BODY_SECTION_BACK" path={BodySectionBack} />
      <External name="BODY_SECTION_BICEPS" path={BodySectionBiceps} />
      <External name="BODY_SECTION_CALVES" path={BodySectionCalves} />
      <External name="BODY_SECTION_CHEST" path={BodySectionChest} />
      <External name="BODY_SECTION_GLUTES" path={BodySectionGlutes} />
      <External name="BODY_SECTION_HAMSTRINGS" path={BodySectionHamstrings} />
      <External name="BODY_SECTION_QUADRICEPS" path={BodySectionQuadriceps} />
      <External name="BODY_SECTION_SHOULDERS" path={BodySectionShoulders} />
      <External name="BODY_SECTION_SPINALS" path={BodySectionSpinals} />
      <External name="BODY_SECTION_TRICEPS" path={BodySectionTriceps} />
      <External name="THREE_DAYS" path={ThreeDays} />
      <External name="FOUR_DAYS" path={FourDays} />
      {/* Videos */}
      <External name="LOGO_ANIMATION_MOV" path={LogoAnimationMov} />
      <External name="LOGO_ANIMATION_WEBM" path={LogoAnimationWebm} />
      <External name="INTRODUCTION" path={Introduction} />
      <External
        name="SHOWCASE"
        path={[
          { path: ShowcaseMov1x, extension: "mov", devicePixelRatio: 1 },
          { path: ShowcaseMov1x, extension: "mov", devicePixelRatio: 2 },
          { path: ShowcaseWebm1x, extension: "webm", devicePixelRatio: 1 },
          { path: ShowcaseWebm1x, extension: "webm", devicePixelRatio: 2 },
        ]}
      />
      <External
        name="STEP1"
        path={[
          { path: Step1Mov1x, extension: "mov", devicePixelRatio: 1 },
          { path: Step1Mov1x, extension: "mov", devicePixelRatio: 2 },
          { path: Step1Webm1x, extension: "webm", devicePixelRatio: 1 },
          { path: Step1Webm1x, extension: "webm", devicePixelRatio: 2 },
        ]}
      />
      <External
        name="STEP2"
        path={[
          { path: Step2Mov1x, extension: "mov", devicePixelRatio: 1 },
          { path: Step2Mov1x, extension: "mov", devicePixelRatio: 2 },
          { path: Step2Webm1x, extension: "webm", devicePixelRatio: 1 },
          { path: Step2Webm1x, extension: "webm", devicePixelRatio: 2 },
        ]}
      />
      <External
        name="STEP3"
        path={[
          { path: Step3Mov1x, extension: "mov", devicePixelRatio: 1 },
          { path: Step3Mov1x, extension: "mov", devicePixelRatio: 2 },
          { path: Step3Webm1x, extension: "webm", devicePixelRatio: 1 },
          { path: Step3Webm1x, extension: "webm", devicePixelRatio: 2 },
        ]}
      />
      <External
        name="BONUS1"
        path={[
          { path: Bonus1Mov1x, extension: "mov", devicePixelRatio: 1 },
          { path: Bonus1Mov1x, extension: "mov", devicePixelRatio: 2 },
          { path: Bonus1Webm1x, extension: "webm", devicePixelRatio: 1 },
          { path: Bonus1Webm1x, extension: "webm", devicePixelRatio: 2 },
        ]}
      />
      <External
        name="BONUS2"
        path={[
          { path: Bonus2Mov1x, extension: "mov", devicePixelRatio: 1 },
          { path: Bonus2Mov1x, extension: "mov", devicePixelRatio: 2 },
          { path: Bonus2Webm1x, extension: "webm", devicePixelRatio: 1 },
          { path: Bonus2Webm1x, extension: "webm", devicePixelRatio: 2 },
        ]}
      />
      <External
        name="BONUS3"
        path={[
          { path: Bonus3Mov1x, extension: "mov", devicePixelRatio: 1 },
          { path: Bonus3Mov1x, extension: "mov", devicePixelRatio: 2 },
          { path: Bonus3Webm1x, extension: "webm", devicePixelRatio: 1 },
          { path: Bonus3Webm1x, extension: "webm", devicePixelRatio: 2 },
        ]}
      />
        <External name="TESTIMONIAL_1" path={Testimonial1} />
        <External name="TESTIMONIAL_2" path={Testimonial2} />
        <External name="TESTIMONIAL_3" path={Testimonial3} />
        <External name="RESULTS" path={Results} />
        <External name="RESULTS_POSTER" path={ResultsPoster} />
    </Externals>
  );
});
